export default __webpack_public_path__ + "static/media/download.06a0763d.svg";